import React, { useState, useEffect } from 'react'
import './affidavit.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faFileLines, faQuestionCircle, faRefresh, faSearch, faTrash } from '@fortawesome/free-solid-svg-icons'
import { Link,useParams } from 'react-router-dom'
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import BackLoader from '../../components/backloader'
import TopBar from '../../components/topbar'
import { useNavigate } from 'react-router-dom'
import JisAlert from '../../components/jisalert'


function Templates() {

    const [openSuccess, setOpenSuccess] = useState(false)
    const {temptype} = useParams();
    const [deleteBox, setDeleteBox] = useState(false)
    const tempUrl= `${Constants.apiUrl}/gazette/templates/${temptype}`;
    const [templates, setTemplates]=useState([]);

    const [filterTemps, setFilterTemps]=useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [index, setIndex] =useState(-1);
    const [search, setSearch] = useState('');
    const [deleteobj, setDeleteObj] = useState ({});
    const [alert, setAlert] = useState({open:false})



    const navigate = useNavigate();
    

      useEffect(() => {     
            LoadTemplates();
      }, [temptype])


    const LoadTemplates=()=>{
         setIsLoading(true);
         fetch(tempUrl, {
             method: 'GET',
             headers: {
               'Content-type': 'application/json',
             },
           })
             .then((resp) => resp.json())
             .then((data) => {
                 setIsLoading(false);
                 if(data.code==0){
                     setTemplates(data.templates);
                     setFilterTemps(data.templates);
                 }
                 
             })
             .catch(error => {
                 console.error(error);
                 setIsLoading(false);
             })
     }

     const onSearch=(ee)=>{
        setSearch(ee);
        if(ee!=''){
        const _filterSearch = templates?.filter(item => {
              const searchValue = item.title.toLowerCase().includes(ee.toLowerCase())
          
              return searchValue;
            })
        setFilterTemps(_filterSearch);
        }else{
            setFilterTemps(templates);
        }
        
        setSearch(ee);
      }

     const onDelete =async()=>{
        setDeleteBox(false);
        setIsLoading(true);
        try {
            const theurl=`${Constants.apiUrl}/gazette/template/${deleteobj.id}/remove`;
            const resp = await fetch(theurl, {
              method: 'POST',
              body: JSON.stringify({}),
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const responseData = await resp.json();
            setIsLoading(false);
            console.log(responseData);
            if (responseData.code === 0 ) {
              //on this back
              setAlert(  {open:true,title:'Template', subtitle:"Delete successfully", onOk});
                //filter one off the table
                const pp = filterTemps.filter((c) => c.id !=deleteobj.id) ;
                const pp_ =templates.filter((c) => c.id !=deleteobj.id) ;
                setFilterTemps(pp);
                setTemplates(pp_);
                setDeleteObj({});
            }else {
                setAlert(  {open:true,title:'Placeholder', subtitle:responseData.status, onOk});
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            setAlert(  {open:true,title:'Placeholder', subtitle:"Please clear the content in it and save empty template before you can delete it", onOk});
          }
     }

     const onOk =()=>{
        setAlert({open:false});
    }

     const openDelete=(obj)=>{
       // setIndex(ind);
        setDeleteObj(obj);
        setDeleteBox(true);

     } 

     const onReset=()=>{
        setSearch('');
        setFilterTemps(templates);
     }

     const onNewTemplate=()=>{
       // `/templates/${doc.id}/view`
       navigate(`/templates/${temptype}/create`)
     }

  return (
    <div className='affidavit-table'>
        <Sidebar />
        <div className="body">
            
            <TopBar title="Home/ Templates" />

            <div className="search-table">
                <div className="form-inp">
                   
                    <input type="text" placeholder='Search by Title' id='search-title' value={search} onChange={(e)=> onSearch(e.target.value)}/>
                </div>
                <button className='red'>Search <FontAwesomeIcon icon={faSearch} /></button>
                <div className="reset-fields" onClick={onReset}>
                    <p>Reset Fields</p>
                    <FontAwesomeIcon icon={faRefresh} />
                </div>
            </div>
            <div className="aff-table">
                <div className="all-div">
                    <FontAwesomeIcon icon={faFileLines} />
                    <h3 style={{flex:1}}> {Constants.TitleCase(temptype) } Templates</h3>
                    <div style={{textAlign:'right'}}><button className='black' onClick={onNewTemplate}> New Template</button></div>
                </div>
                <div className="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Document ID</th>
                                <th>Date Created</th>
                                <th>Type</th>
                                <th>Action</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                filterTemps.map((doc, i) => { return (
                                    <tr key={i}>
                                        <td>{doc.title}</td>
                                        <td>{doc.id}</td>
                                        <td>{Constants.formatDate(doc.dateCreated) }</td>
                                        <td>{doc.type==1?'DOCUMENT':'AFFIDAVIT'} </td>
                                        <td className='view-affbtn'>
                                            <Link to={`/templates/${doc.id}/view`}><button>View <FontAwesomeIcon icon={faAngleRight} /></button></Link>
                                        </td>
                                        <td className='del-aff' onClick={() => openDelete(doc)}>Delete <FontAwesomeIcon icon={faTrash} /></td>
                                    </tr>
                                )})
                            } 
                        </tbody>
                    </table>
                </div>
            </div>
         {deleteBox && <div className={ "delete-box open" }>
                <div className="delete-wrap">
                    <FontAwesomeIcon icon={faQuestionCircle} />
                    <h2>Do you want to delete this. {temptype} Template ({deleteobj.title})? Please confirm no other document is using it or used it. Instead Edit it. Yes to Continue to Delete</h2>
                    <div className="del-btns">
                        <button className='red' onClick={onDelete}>Yes</button>
                        <button className='black' onClick={() => setDeleteBox(false)}>Cancel</button>
                    </div>
                </div>
            </div>}   
            {openSuccess && <div className={ "success open" }>
                <div className="success-box">
                    <h2>Successful</h2>
                    <p> Template deleted successfully</p>
                    <button className='red' onClick={()=> setOpenSuccess(false)}>Continue</button>
                </div>
            </div>}

        </div>
        <BackLoader open={isLoading}  />
        {alert.open && <JisAlert {...alert}/>}  
    </div>
  )
}

export default Templates